import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapAtheletesComponent } from './components/bootstrap-atheletes/bootstrap-atheletes.component';

const routes: Routes = [{path:'', component:BootstrapAtheletesComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AthletesRoutingModule { }
